module.exports = __webpack_public_path__ + "img/f88325c.svg";